








































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { PanelModel, QuestionPanelDynamicModel } from "survey-core";
import { default as QuestionVue } from "./question";

@Component
export class PanelDynamic extends QuestionVue<QuestionPanelDynamicModel> {
  get showLegacyNavigation() {
    return this.question["showLegacyNavigation"];
  }
}
Vue.component("survey-paneldynamic", PanelDynamic);
export default PanelDynamic;
